import { Layout, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import SearchSerie from "../series/SearchSerie";
import { useOutlet } from "react-router-dom";
import HeaderHome from "./HeaderHome";
import NextReleases from "./NextRelease";

const { Title } = Typography;

const Home = () => {
  const outlet = useOutlet();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <HeaderHome />
      <Content style={{ margin: "16px 100px" }}>
        <NextReleases />
        <Title level={3}>Rechercher une série</Title>
        {outlet || <SearchSerie renderType={"card"} />}
      </Content>
    </Layout>
  );
};

export default Home;
